import React from "react";
import { useTranslation } from "react-i18next";
import LegalLayout from "./LegalLayout";

export default function CookiePolicy() {
  const { i18n } = useTranslation();
  const isTh = i18n.language?.startsWith("th") ?? true;

  const sections = isTh
    ? [
        {
          h: "1. คุกกี้คืออะไร",
          p: "คุกกี้ (Cookies) คือไฟล์ข้อมูลขนาดเล็กที่เว็บไซต์จัดเก็บไว้ในเบราว์เซอร์ของท่าน เพื่อจดจำการเข้าใช้งาน เช่น ภาษาที่เลือก หรือสถานะการเข้าสู่ระบบ คุกกี้ช่วยให้เว็บไซต์ทำงานได้ดีขึ้นและมีประสิทธิภาพมากขึ้น",
        },
        {
          h: "2. ประเภทของคุกกี้ที่เราใช้",
          p: "(1) คุกกี้ที่จำเป็น (Necessary): จำเป็นสำหรับการทำงานพื้นฐานของเว็บไซต์ เช่น การจดจำภาษา (2) คุกกี้วิเคราะห์ (Analytics): ช่วยให้เราเข้าใจการใช้งานเว็บไซต์ของท่าน (3) คุกกี้การตลาด (Marketing): ใช้สำหรับแสดงเนื้อหาที่ตรงกับความสนใจของท่าน (4) คุกกี้การทำงาน (Functional): ช่วยให้เว็บไซต์มีฟีเจอร์เพิ่มเติม เช่น แชทบอท",
        },
        {
          h: "3. การจัดการคุกกี้",
          p: "ท่านสามารถจัดการความยินยอมในการใช้คุกกี้ได้ผ่านแบนเนอร์คุกกี้ที่ปรากฏเมื่อเข้าใช้งานครั้งแรก หรือผ่านการตั้งค่าของเบราว์เซอร์ที่ท่านใช้ การปิดคุกกี้บางประเภทอาจทำให้บางฟีเจอร์ของเว็บไซต์ทำงานไม่สมบูรณ์",
        },
        {
          h: "4. คุกกี้ของบุคคลที่สาม",
          p: "เว็บไซต์ของเราอาจใช้บริการของบุคคลที่สาม เช่น Google Analytics หรือเครื่องมือวิเคราะห์อื่น ๆ ซึ่งบริการเหล่านี้อาจตั้งค่าคุกกี้บนเบราว์เซอร์ของท่าน โปรดศึกษานโยบายคุกกี้ของผู้ให้บริการแต่ละรายเพิ่มเติม",
        },
        {
          h: "5. การติดต่อ",
          p: "หากท่านมีคำถามเกี่ยวกับการใช้คุกกี้ของเรา โปรดติดต่อ โทร. 02-276-9968 หรืออีเมล oaoffice@ornthai.com",
        },
      ]
    : [
        {
          h: "1. What are Cookies?",
          p: "Cookies are small data files a website stores in your browser to remember your visits — such as your preferred language or login state. Cookies help the site work better and more efficiently.",
        },
        {
          h: "2. Types of Cookies We Use",
          p: "(1) Necessary: required for basic site functions like language preference; (2) Analytics: help us understand how you use the site; (3) Marketing: used to show content matched to your interests; (4) Functional: enable extra features like chat.",
        },
        {
          h: "3. Managing Cookies",
          p: "You can manage your cookie consent through the banner shown on first visit, or in your browser settings. Disabling some cookies may cause certain site features to stop working as intended.",
        },
        {
          h: "4. Third-Party Cookies",
          p: "Our site may use third-party services such as Google Analytics or similar tools, which may set cookies in your browser. Please review each provider's cookie policy for details.",
        },
        {
          h: "5. Contact",
          p: "If you have questions about our use of cookies, please contact us at +66 2-276-9968 or oaoffice@ornthai.com.",
        },
      ];

  return (
    <LegalLayout
      title={isTh ? "นโยบายคุกกี้" : "Cookie Policy"}
      subtitle={isTh ? "Cookie Policy" : "Cookie Policy"}
      lastUpdated={isTh ? "ปรับปรุงล่าสุด: 11 พฤษภาคม 2569" : "Last Updated: May 11, 2026"}
      sections={sections}
    />
  );
}
